function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 70,
  cy: 70,
  r: 70,
  fill: "#0085FF",
  fillOpacity: 0.08
});
var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#empty-search-results_svg__filter0_d)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 30,
  y: 34,
  width: 159,
  height: 61,
  rx: 1,
  fill: "#fff"
}));
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#0085FF",
  fillOpacity: 0.1,
  d: "M62 48h120v6H62zM62 75h120v6H62z"
});
var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 51,
  r: 11,
  fill: "#DBDFE5",
  stroke: "#fff",
  strokeWidth: 2
});
var _ref5 = /*#__PURE__*/React.createElement("mask", {
  id: "empty-search-results_svg__a",
  maskUnits: "userSpaceOnUse",
  x: 37,
  y: 41,
  width: 20,
  height: 20
}, /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 51,
  r: 10,
  fill: "#DBDFE5"
}));
var _ref6 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#empty-search-results_svg__a)",
  fill: "#A0AFBE"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 61,
  r: 10
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 47.818,
  r: 5.048,
  stroke: "#DBDFE5",
  strokeWidth: 1.914
}));
var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 78,
  r: 11,
  fill: "#DBDFE5",
  stroke: "#fff",
  strokeWidth: 2
});
var _ref8 = /*#__PURE__*/React.createElement("mask", {
  id: "empty-search-results_svg__b",
  maskUnits: "userSpaceOnUse",
  x: 37,
  y: 68,
  width: 20,
  height: 20
}, /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 78,
  r: 10,
  fill: "#DBDFE5"
}));
var _ref9 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#empty-search-results_svg__b)",
  fill: "#A0AFBE"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 88,
  r: 10
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 74.818,
  r: 5.048,
  stroke: "#DBDFE5",
  strokeWidth: 1.914
}));
var _ref0 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M124.714 109.429c11.44 0 20.715-9.275 20.715-20.715S136.154 68 124.714 68 104 77.274 104 88.714s9.274 20.715 20.714 20.715z",
  fill: "#0085FF",
  fillOpacity: 0.05,
  stroke: "#A0AFBE",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref1 = /*#__PURE__*/React.createElement("path", {
  d: "M141.286 105.286L162 126",
  stroke: "#A0AFBE",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "empty-search-results_svg__filter0_d",
  x: 22,
  y: 28,
  width: 175,
  height: 77,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));
function SvgEmptySearchResults(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 140,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref0, _ref1, _ref10);
}
export default SvgEmptySearchResults;